var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pictureGraph",class:['picture-info-wrap', _vm.shows]},[_c('div',{staticClass:"info-content"},[_c('div',{ref:"infoBody",staticClass:"info-body"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.desc)}})]),(_vm.isOver)?_c('v-btn',{on:{"btnClick":_vm.expand_more}},[_c('v-icon',[_vm._v("expand_more")])],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }